import { CONSTS } from 'config/objectConst'
import { useState } from 'react'

import { api } from '../../api'
import { useRequestParams } from '../../hooks/request-params'

export function useLoadTable() {
	const [params, isFiltered] = useRequestParams()

	const [page, setPage] = useState(0)

	const query = api.useCampaignsPageQuery(
		{
			...params,
			$skip: page * CONSTS.PAGE_SIZE,
			$take: CONSTS.PAGE_SIZE
		},
		{
			refetchOnMountOrArgChange: true
		}
	)

	// useAutomationEnded(() => {
	// 	query.refetch()
	// })

	const campaigns = query.data?.documents ?? []

	const isEmpty = query.isSuccess && campaigns.length === 0
	const isEmptyFilterResult = isEmpty && isFiltered
	const isNotExistAtAll = isEmpty && !isFiltered
	const isHasItems = query.isSuccess && campaigns.length > 0

	return {
		isEmptyFilterResult,
		isHasItems,
		isNotExistAtAll,
		page,
		props: {
			campaigns,
			page,
			setPage,
			total: query.data?.total ?? 0
		},
		query,
		setPage
	}
}
